module.exports = __webpack_public_path__ + "media/images/badge/infallibile-9465f08dd5c1b4fc3614ecbc644cad22.png";